import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

export default function TermsAndConditions() {
  return (
    <div className="legal-page">

      {/* Hero Banner */}
      <div className="legal-hero">
        <div className="legal-hero-grid" />
        <div className="legal-hero-orb" />
        <div className="legal-hero-content">
          <div className="legal-breadcrumb">
            <Link to="/">Home</Link>
            <span className="legal-breadcrumb-sep">→</span>
            <span>Terms &amp; Conditions</span>
          </div>
          <h1 className="legal-hero-title">Terms &amp; Conditions</h1>
          <p className="legal-hero-sub">
            Please read these terms carefully before accessing or using the
            services of Kelwa Technologies Private Limited.
          </p>
          <div className="legal-effective">
            <span>Effective: 01 January 2025</span>
            <div className="legal-effective-dot" />
            <span>Last Updated: 01 March 2025</span>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="legal-body">
        <div className="legal-body-inner">

          {/* Sidebar TOC */}
          <aside className="legal-toc">
            <div className="legal-toc-title">Contents</div>
            <ol className="legal-toc-list">
              {[
                'Agreement to Terms',
                'Description of Services',
                'Intellectual Property',
                'User Obligations',
                'Limitation of Liability',
                'Confidentiality',
                'Warranties & Disclaimers',
                'Indemnification',
                'Governing Law',
                'Dispute Resolution',
                'Modifications',
                'Contact',
              ].map((item, i) => (
                <li key={i}><a href={`#tc-${i + 1}`}>{i + 1}. {item}</a></li>
              ))}
            </ol>
          </aside>

          {/* Main Content */}
          <article className="legal-content">

            <section className="legal-section" id="tc-1">
              <h2>1. Agreement to Terms</h2>
              <p>By accessing or using the website or services of Kelwa Technologies Private Limited ("Company", "we", "our", or "us"), you agree to be bound by these Terms and Conditions. These Terms constitute a legally binding agreement between you and the Company.</p>
              <p>If you do not agree with any part of these Terms, please discontinue use of our services immediately. Your continued access to and use of our services constitutes your acceptance of these Terms.</p>
            </section>

            <section className="legal-section" id="tc-2">
              <h2>2. Description of Services</h2>
              <p>Kelwa Technologies Private Limited provides information service activities. Our services include, but are not limited to:</p>
              <ul>
                <li>Data research and analytics</li>
                <li>Information management and processing</li>
                <li>Digital information services and platforms</li>
                <li>Documentation and compliance support</li>
                <li>Intelligent automation of information workflows</li>
                <li>Strategic information consulting</li>
              </ul>
              <p>We reserve the right to modify, suspend, or discontinue any service at any time without notice. We shall not be liable to you or any third party for any modification, suspension, or discontinuation of services.</p>
            </section>

            <section className="legal-section" id="tc-3">
              <h2>3. Intellectual Property</h2>
              <p>All content, trademarks, service marks, logos, trade names, and other intellectual property displayed on our website and within our deliverables remain the exclusive property of Kelwa Technologies Private Limited, unless otherwise explicitly stated.</p>
              <p>You may not reproduce, duplicate, copy, sell, resell, or exploit any portion of our services, use of our services, or access to our services without the express written permission of the Company. Any unauthorised use may violate copyright, trademark, and other applicable laws.</p>
            </section>

            <section className="legal-section" id="tc-4">
              <h2>4. User Obligations</h2>
              <p>By using our services, you represent and warrant that you are of legal age to form a binding contract with the Company. You agree to use our services only for lawful purposes and in compliance with all applicable laws and regulations. You must not:</p>
              <ul>
                <li>Use our services to transmit any unlawful, harmful, threatening, abusive, harassing, defamatory, or otherwise objectionable content</li>
                <li>Attempt to gain unauthorised access to any portion of our website, servers, or networks</li>
                <li>Reproduce, duplicate, copy, or resell any part of our services without prior written consent</li>
                <li>Misrepresent your identity, affiliation, or the source of any information you provide</li>
                <li>Engage in any conduct that restricts or inhibits any other user's access to our services</li>
                <li>Use our services to violate any applicable local, national, or international law or regulation</li>
              </ul>
            </section>

            <section className="legal-section" id="tc-5">
              <h2>5. Limitation of Liability</h2>
              <p>To the fullest extent permitted by applicable law, Kelwa Technologies Private Limited and its directors, employees, partners, agents, suppliers, and affiliates shall not be liable for:</p>
              <ul>
                <li>Any indirect, incidental, special, consequential, or punitive damages</li>
                <li>Loss of profits, revenue, data, goodwill, or other intangible losses</li>
                <li>Any damages resulting from your access to or use of (or inability to access or use) our services</li>
                <li>Any unauthorised access to or use of our servers or any personal information stored therein</li>
              </ul>
              <p>This limitation applies even if we have been advised of the possibility of such damages. Some jurisdictions do not allow the exclusion of certain warranties or limitations of liability, so some of the above may not apply to you.</p>
            </section>

            <section className="legal-section" id="tc-6">
              <h2>6. Confidentiality</h2>
              <p>Both parties agree to maintain strict confidentiality with respect to any proprietary, sensitive, or confidential information shared during the course of engagement. Each party agrees to:</p>
              <ul>
                <li>Use confidential information solely for the purpose for which it was disclosed</li>
                <li>Not disclose confidential information to any third party without prior written consent</li>
                <li>Protect confidential information with the same standard of care used to protect its own confidential information</li>
              </ul>
              <p>This obligation of confidentiality shall survive the termination of any service agreement between the parties for a period of five (5) years.</p>
            </section>

            <section className="legal-section" id="tc-7">
              <h2>7. Warranties &amp; Disclaimers</h2>
              <p>Our services are provided on an "as is" and "as available" basis without warranties of any kind, either express or implied, including but not limited to:</p>
              <ul>
                <li>Implied warranties of merchantability or fitness for a particular purpose</li>
                <li>Warranties that our services will be uninterrupted, error-free, or secure</li>
                <li>Warranties regarding the accuracy, reliability, or completeness of any information provided</li>
              </ul>
              <p>We do not warrant that defects will be corrected or that our website or servers are free of viruses or other harmful components.</p>
            </section>

            <section className="legal-section" id="tc-8">
              <h2>8. Indemnification</h2>
              <p>You agree to indemnify, defend, and hold harmless Kelwa Technologies Private Limited and its officers, directors, employees, agents, and successors from and against any and all claims, losses, liabilities, damages, costs, and expenses (including reasonable legal fees) arising from or related to:</p>
              <ul>
                <li>Your breach of these Terms and Conditions</li>
                <li>Your violation of any applicable law or regulation</li>
                <li>Your violation of any third-party rights</li>
                <li>Your misuse of our services</li>
              </ul>
            </section>

            <section className="legal-section" id="tc-9">
              <h2>9. Governing Law</h2>
              <p>These Terms and Conditions shall be governed by and construed in accordance with the laws of the Republic of India, without regard to its conflict of law provisions. Any legal action or proceeding arising out of or relating to these Terms shall be subject to the exclusive jurisdiction of the competent courts of India.</p>
            </section>

            <section className="legal-section" id="tc-10">
              <h2>10. Dispute Resolution</h2>
              <p>In the event of any dispute, claim, or controversy arising out of or in connection with these Terms, the parties agree to first attempt resolution through good-faith negotiation. Either party may initiate the negotiation process by providing written notice to the other party.</p>
              <p>If the dispute is not resolved through negotiation within thirty (30) days of such notice, the dispute shall be referred to and finally resolved by arbitration in accordance with the Arbitration and Conciliation Act, 1996 of India. The place of arbitration shall be India, and the language of arbitration shall be English.</p>
            </section>

            <section className="legal-section" id="tc-11">
              <h2>11. Modifications</h2>
              <p>We reserve the right to modify, revise, or update these Terms and Conditions at any time at our sole discretion. When we make changes, we will update the "Last Updated" date at the top of this page.</p>
              <p>It is your responsibility to review these Terms periodically. Your continued use of our services following the posting of any changes constitutes your acceptance of such changes. If you do not agree with the modified terms, you must discontinue use of our services.</p>
            </section>

            <section className="legal-section" id="tc-12">
              <h2>12. Contact</h2>
              <p>If you have any questions about these Terms and Conditions or wish to report any concerns, please contact our legal team:</p>
              <div className="legal-contact-box">
                <div className="legal-contact-row">
                  <span className="legal-contact-label">Company</span>
                  <span>Kelwa Technologies Private Limited</span>
                </div>
                <div className="legal-contact-row">
                  <span className="legal-contact-label">Email</span>
                  <span>legal@kelwatechnologies.in</span>
                </div>
                <div className="legal-contact-row">
                  <span className="legal-contact-label">Country</span>
                  <span>India</span>
                </div>
              </div>
            </section>

          </article>
        </div>
      </div>

    </div>
  );
}
